export default __webpack_public_path__ + "static/callipers-ea96a95d4720037ab3e99efe73b35dcb.png";